(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["textura-modo-empleo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('#texture-use-{{ section.id }}');

    if (!section) return;

    const track = section.querySelector('.texture-use__track');
    const slides = section.querySelectorAll('.texture-use__slide');
    const dotsContainer = section.querySelector('.texture-use__dots');
    const caption = section.querySelector('.texture-use__caption');
    const previousButton = section.querySelector('.texture-use__button--prev');
    const nextButton = section.querySelector('.texture-use__button--next');

    if (!track || !slides.length) return;

    let currentSlide = 0;

    slides.forEach((slide, index) => {
      const dot = document.createElement('button');

      dot.type = 'button';
      dot.className = 'texture-use__dot';
      dot.setAttribute('aria-label', `Ver vídeo ${index + 1}`);

      dot.addEventListener('click', () => {
        currentSlide = index;
        updateCarousel();
      });

      dotsContainer.appendChild(dot);
    });

    const dots = dotsContainer.querySelectorAll('.texture-use__dot');

    function updateCarousel() {
      track.style.transform = `translateX(-${currentSlide * 100}%)`;

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentSlide);
      });

      caption.textContent = slides[currentSlide].dataset.caption || '';
    }

    previousButton.addEventListener('click', () => {
      currentSlide = currentSlide === 0 ? slides.length - 1 : currentSlide - 1;
      updateCarousel();
    });

    nextButton.addEventListener('click', () => {
      currentSlide = currentSlide === slides.length - 1 ? 0 : currentSlide + 1;
      updateCarousel();
    });

    updateCarousel();
  })();

  } catch(e) { console.error(e); }
})();
})();
